import { VFC } from 'react'
import { Link } from 'react-router-dom'

import { useTranslation } from 'react-i18n-lite'
import { Taskmodel } from 'taskmodel/shared/types'
import { useActionHandler } from 'task/shared/hooks'

type TaskProps = {
  taskmodel: Taskmodel
  workflowUuid: string
  dataContainer: {
    [key: string]: string
  }
  isActive?: boolean
  withWorkflowLink?: boolean
}

const TaskAction: VFC<TaskProps> = ({
  taskmodel,
  workflowUuid,
  dataContainer,
  isActive = true,
  withWorkflowLink = false
}) => {
  const { url, label } = useActionHandler({
    taskmodel,
    workflowUuid,
    dataContainer
  })
  const { t } = useTranslation()

  const renderCurrentTaskmodel = (): JSX.Element => {
    return (
      <Link to={url} className='btn btn-secondary'>
        {label}
      </Link>
    )
  }

  return (
    <li className='m-2'>
      {isActive && renderCurrentTaskmodel()}

      {!isActive && (
        <button disabled className='btn btn-secondary'>
          {taskmodel.des}
        </button>
      )}

      {withWorkflowLink && (
        <Link className='ms-2' to={`/workflow/${workflowUuid}`}>
          {t('task.go-to-workflow')}
        </Link>
      )}
    </li>
  )
}

export default TaskAction
